(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/sortBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/sortBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.sortBy, global.convert);
    global.sortBy = mod.exports;
  }
})(this, function (exports, _sortBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.sortBy = undefined;

  var _sortBy3 = _interopRequireDefault(_sortBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of sorted by <code>iteratees</code>.
   * @function
   * @memberof collection
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[{@link https://lodash.com/docs#identity|lodash.identity}]] The iteratees to sort by.
   * @return {Object} Returns the updated object.
   * @see {@link https://lodash.com/docs#sortBy|lodash.sortBy} for more information.
   * @example
   * sortBy({ nested: { prop: [{ name: 'Yvo', age: 2 }, { name: 'Nico', age: 666 }, { name: 'Nico', age: 30 }] } }, 'nested.prop', ['name', 'age'])
   * // => { nested: { prop: [{ name: 'Nico', age: 30 }, { name: 'Nico', age: 666 }, { name: 'Yvo', age: 2 }] } }
   * @since 0.3.0
   */
  var sortBy = (0, _convert.convert)(_sortBy3.default);
  exports.sortBy = sortBy;
  exports.default = sortBy;
});